// extracted by mini-css-extract-plugin
export var searchHeader = "_4z-0";
export var searchHeaderDark = "_4z-1";